import { Callout } from "@radix-ui/themes";
import { getErrorMessage } from "../client/auth-client-errors";

type AuthErrorMessageProps = {
  error?: unknown;
  message?: string;
};

export function AuthErrorMessage({ error, message }: AuthErrorMessageProps) {
  const text = message ?? (error != null ? getErrorMessage(error) : undefined);

  if (!text) return null;

  return (
    <Callout.Root color="red" role="alert">
      <Callout.Text>{text}</Callout.Text>
    </Callout.Root>
  );
}
